"use client";

import { useState, useEffect } from "react";
import WorkshopCard from "./WorkshopCard";

export default function WorkshopSection({ workshops, mentors }) {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  return (
    <section
      className={`py-16 ${isDesktop ? 'w-[80%]' : 'w-[90%] md:w-[80%]'} mx-auto`}
      id="mentorship"
    >

      <h2 className={`text-[#002726] font-medium mb-6 ${isDesktop ? 'text-xl' : 'text-xl md:text-xl'}`}>
        Workshops
      </h2>

      {isDesktop ? (
        <div className="grid grid-cols-[repeat(auto-fit,315px)] justify-between gap-y-10 gap-x-8">
          {workshops.map((workshop, index) => (
            <div key={workshop.id} className="w-[315px] h-[426px]">
              <WorkshopCard workshop={workshop} mentors={mentors} priority={index < 6} />
            </div>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {workshops.map((workshop, index) => (
            <WorkshopCard key={workshop.id} workshop={workshop} mentors={mentors} priority={index < 3} />
          ))}
        </div>
      )}
    </section>
  );
}